define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrCrStatusDomain = void 0;
    class SrCrStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: SrCrStatusDomain.Draft, value: "Draft" },
                    { key: SrCrStatusDomain.Submitted, value: "Submitted" },
                    { key: SrCrStatusDomain.EndorsedForConsultation, value: "Endorsed for Consultation" },
                    { key: SrCrStatusDomain.ReleasedForConsultation, value: "Released for Consultation" },
                    { key: SrCrStatusDomain.ConsultationApproved, value: "Consultation Approved" },
                    { key: SrCrStatusDomain.SubmissionRejected, value: "Submission Rejected" },
                    { key: SrCrStatusDomain.ConsultationRejected, value: "Consultation Rejected" },
                    { key: SrCrStatusDomain.ReleaseForConsultationRejected, value: "Release for Consultation Rejected" },
                    { key: SrCrStatusDomain.CertificationRejected, value: "Certification Rejected" },
                    { key: SrCrStatusDomain.Certified, value: "Certified" },
                    { key: SrCrStatusDomain.Cancelled, value: "Cancelled" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[SrCrStatusDomain.Draft] = 0;
                this.KeyIndex[SrCrStatusDomain.Submitted] = 1;
                this.KeyIndex[SrCrStatusDomain.EndorsedForConsultation] = 2;
                this.KeyIndex[SrCrStatusDomain.ReleasedForConsultation] = 3;
                this.KeyIndex[SrCrStatusDomain.ConsultationApproved] = 4;
                this.KeyIndex[SrCrStatusDomain.SubmissionRejected] = 5;
                this.KeyIndex[SrCrStatusDomain.ConsultationRejected] = 6;
                this.KeyIndex[SrCrStatusDomain.ReleaseForConsultationRejected] = 7;
                this.KeyIndex[SrCrStatusDomain.CertificationRejected] = 8;
                this.KeyIndex[SrCrStatusDomain.Certified] = 9;
                this.KeyIndex[SrCrStatusDomain.Cancelled] = 10;
                this.ValueIndex = {};
                this.ValueIndex["Draft"] = 0;
                this.ValueIndex["Submitted"] = 1;
                this.ValueIndex["Endorsed for Consultation"] = 2;
                this.ValueIndex["Released for Consultation"] = 3;
                this.ValueIndex["Consultation Approved"] = 4;
                this.ValueIndex["Submission Rejected"] = 5;
                this.ValueIndex["Consultation Rejected"] = 6;
                this.ValueIndex["Release for Consultation Rejected"] = 7;
                this.ValueIndex["Certification Rejected"] = 8;
                this.ValueIndex["Certified"] = 9;
                this.ValueIndex["Cancelled"] = 10;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.SrCrStatusDomain = SrCrStatusDomain;
    Object.defineProperty(SrCrStatusDomain, "Draft", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "D"
    });
    Object.defineProperty(SrCrStatusDomain, "Submitted", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "S"
    });
    Object.defineProperty(SrCrStatusDomain, "EndorsedForConsultation", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "CONE"
    });
    Object.defineProperty(SrCrStatusDomain, "ReleasedForConsultation", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "CONREL"
    });
    Object.defineProperty(SrCrStatusDomain, "ConsultationApproved", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "CONA"
    });
    Object.defineProperty(SrCrStatusDomain, "SubmissionRejected", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SR"
    });
    Object.defineProperty(SrCrStatusDomain, "ConsultationRejected", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "CONR"
    });
    Object.defineProperty(SrCrStatusDomain, "ReleaseForConsultationRejected", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "CONER"
    });
    Object.defineProperty(SrCrStatusDomain, "CertificationRejected", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "CERR"
    });
    Object.defineProperty(SrCrStatusDomain, "Certified", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "CERA"
    });
    Object.defineProperty(SrCrStatusDomain, "Cancelled", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "C"
    });
    Object.defineProperty(SrCrStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
